import Vue from 'vue'
import TDesign from 'tdesign-vue'
import 'tdesign-vue/es/style/index.css'

Vue.use(TDesign)
